var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c("section-title", {
        staticClass: "my-4",
        attrs: {
          "bg-icon": "bg-green",
          "has-line": false,
          icon: "fas fa-bell",
          reverse: true,
          title: "Certificación de Conflicto de Interés"
        }
      }),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "ml-md-2" },
        [
          _c(
            "validation-observer",
            { ref: "noConflicts" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("question-box-radio-button", {
                          attrs: {
                            "custom-error-msg":
                              "Favor seleccionar una de las opciones.",
                            error: errors[0],
                            label: _vm.question,
                            options: _vm.answers
                          },
                          model: {
                            value: _vm.answer,
                            callback: function($$v) {
                              _vm.answer = $$v
                            },
                            expression: "answer"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.answer && _vm.answer.value === "NO"
        ? _c(
            "div",
            [
              _c("section-title", {
                staticClass: "my-4 ml-md-2",
                attrs: {
                  "bg-icon": "bg-green",
                  "has-line": false,
                  icon: "fas fa-bell",
                  reverse: true,
                  title: "Certificación de Confidencialidad de Datos"
                }
              }),
              _vm._m(1)
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex mt-4 justify-content-end" },
        [
          _c(
            "action-button",
            {
              staticClass: "mr-2",
              attrs: {
                i: "fas fa-arrow-circle-left",
                variant: "outline-success"
              },
              on: { click: _vm.goBack }
            },
            [_vm._v(" Regresar ")]
          ),
          _vm.canContinue
            ? _c(
                "action-button",
                {
                  attrs: { i: "fas fa-arrow-circle-right", variant: "success" },
                  on: { click: _vm.confirmationHandler }
                },
                [_vm._v(" Continuar ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ml-md-4" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          " CERTIFICACIÓN DE AUSENCIA DE CONFLICTO DE INTERESES PARA EVALUADORES DE PROPUESTAS SOMETIDAS A LA SECRETARÍA ASOCIADA DE "
        ),
        _c("br"),
        _vm._v(" EDUCACIÓN ESPECIAL DEL DEPARTAMENTO DE EDUCACIÓN ")
      ]),
      _c("p", [
        _vm._v(
          " Su designación como miembro del Comité Evaluador de Propuestas del Departamento de Educación requiere de su conocimiento sobre la reglamentación federal relacionada al conflicto de intereses y a la naturaleza privilegiada de este proceso. Antes de evaluar propuestas como Evaluador Principal o Secundario, usted debe informar a la Secretaría Auxiliar de Asuntos Federales sobre cualquier conflicto de intereses o aparente conflicto con este proceso. "
        )
      ]),
      _c("p", [
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v("Conflicto de Interés:")
        ]),
        _vm._v(
          " Un conflicto de interés o aparente conflicto puede ocurrir si usted tiene directa o indirectamente alguna afiliación con la organización que sometió una propuesta a esta agencia para evaluación bajo algún programa para el cual usted ha sido designado evaluador. Como evaluador, usted debe informar al personal de la Secretaría Auxiliar de Asuntos Federales sobre cualquier conflicto potencial que puede existir entre usted y la organización. A continuación se describen ejemplos de posibles situaciones conflictivas: "
        )
      ]),
      _c("p", [
        _vm._v(
          " Someter una propuesta personal al Departamento de Educación: Si ha sometido una propuesta o ha estado involucrado personalmente con la preparación de una propuesta para evaluación bajo algún programa para el cual usted ha sido designado como evaluador, no puede ser parte del Comité Evaluador de Propuestas. "
        )
      ]),
      _c("p", [
        _vm._v(
          " Tener algún tipo de afiliación con la institución u organización que sometió propuesta para evaluación bajo algún programa para el cual usted ha sido designado como evaluador. Un conflicto puede estar presente si usted: "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Tiene un empleo actual o está siendo considerado para empleo en la organización solicitante. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Realizó algún arreglo formal o informal de empleo con la organización, incluyendo asesoramiento, consultoría u otra posición similar. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Posee membresía actual con el comité visitante, junta directiva o un cuerpo similar de la organización. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Tiene cualquier oficina, membresía en la junta de gobierno o comité relevante dentro de la organización. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Es estudiante activo (esto sería un conflicto si una de las propuestas sometidas provienen de un departamento o escuela dentro del cual es un colaborador o estudiante). "
        )
      ]),
      _c("p", [
        _vm._v(
          " - Recibió o retiene premio de la organización solicitante por los pasados doce (12) meses. "
        )
      ]),
      _c("p", [
        _vm._v(
          " Tener relación con algún individuo que tenga interés personal en la propuesta para evaluación bajo algún programa para el cual usted ha sido designado como evaluador como resultado de: "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("- Matrimonio o relación familiar.")
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("- Relación profesional o de negocios.")
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Empleo en la misma institución por los pasados doce (12) meses. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " - Su asociación pasada o presente como consejero de tesis o estudiante de tesis. "
        )
      ]),
      _c("p", [
        _vm._v(
          " - Su colaboración en un proyecto, libro, artículo o informe en los pasados cuarenta y ocho (48) meses. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("Otras afiliaciones o relaciones:")
      ]),
      _c("p", [
        _vm._v(
          " Los intereses de las siguientes personas deben ser tratados como si fuesen suyos: esposo(a), hijos, familiares que residen en su hogar inmediato o cualquier persona que se le considere legalmente su compañero para el cual usted entiende que puede ser cubierto por las secciones 1, 2 o 3 de esta certificación. "
        )
      ]),
      _c("p", [
        _vm._v(
          " Cualquier otra persona con la cual usted tenga una relación de amistad o que usted crea que pueda afectarle su juicio. "
        )
      ]),
      _c("p", [
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v("Confidencialidad de Evaluadores:")
        ]),
        _vm._v(
          " La identidad de los evaluadores es confidencial. Las organizaciones pueden solicitarle a la Secretaría Asociada de Educación Especial, información sobre la evaluación de su propuesta. No obstante, cuando dicha información es divulgada a la organización solicitante, los nombres de los evaluadores deben ser eliminados y protegidos. Como evaluador, usted no debe discutir los nombres de los evaluadores con los proponentes o con alguna otra persona. "
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "ml-md-4" }, [
      _vm._v(
        " Como evaluador me comprometo a mantener en estricta confidencialidad la información presentada en la propuesta asignada. Dicha información será exclusivamente utilizada para propósitos de evaluación. En este proceso me comprometo a no reproducir, modificar, hacer pública o divulgar a terceros la información sobre la propuesta evaluada. "
      ),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(
          " De no cumplir con este compromiso, seré responsable de las consecuencias o repercusiones que dicho incumplimiento llegase a ocasionarle a la Secretaría Asociada de Educación Especial y al Departamento de Educación de Puerto Rico. "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }